import { reactive, toRefs, provide, inject, computed } from "@vue/composition-api";
import { activity } from "../../api";
import { actions as taskActions } from "./task";

export const state = reactive({
    list: []
});

export const actions = {
    async fetchActivities() {
        let response;
        try {
            response = await activity.get();
            state.list = response;
        } catch (err) {
            //pass
        }
        return response;
    },
    navigateToActivitySource(activity) {
        switch (activity.related_type) {
            case "task":
                taskActions.openTask(activity.related_id);
        }
    }
};
export const getters = {
    activities: computed(() => {
        return state.list;
    })
};
export const key = Symbol("ActivityModule");

export const provideActivity = () =>
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });

export default () => inject(key);
